import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import Company from "../../models/company";
import CompanyLimitsForm from "./CompanyLimitsForm";

interface CompanyLimitsModalProps {
  show: boolean;
  company?: Company;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const CompanyLimitsModal: React.FC<CompanyLimitsModalProps> = ({
  show,
  company,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = company
    ? `Editar límites para Empresa: ${company.legalName}`
    : `Crear límites para Empresa`;

  const onClose = () => {
    onCancel();
  };

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <CompanyLimitsForm
              company={company}
              onCancel={onCancel}
              onSuccess={onSuccess}
              clearOnSuccess={false}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default CompanyLimitsModal;
